import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowUpRight, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSettings } from "../../../core/api/hooks/useSettings";

export const CtaSection = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    const { data: settings } = useSettings();

    const whatsappLink = settings?.whatsapp
        ? `https://wa.me/${settings.whatsapp.replace('+', '')}`
        : '#';

    return (
        <section className="py-20 px-4 md:px-8 max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 border-t border-b border-secondary/20">

                {/* Text Section - Broken Grid Style */}
                <div className="lg:col-span-7 flex flex-col justify-center py-12 lg:py-20 lg:pr-12 border-b lg:border-b-0 lg:border-r border-secondary/20 relative">
                    {/* Vertical Typography Decoration */}
                    <div className="absolute top-0 right-0 hidden lg:flex h-full items-center justify-center w-12 border-l border-secondary/10 -mr-6 z-0 pointer-events-none opacity-20">
                        <span className="transform -rotate-90 whitespace-nowrap text-xs tracking-[0.3em] font-mono text-secondary uppercase">
                            Invest in Excellence
                        </span>
                    </div>

                    <h2 className="text-4xl md:text-6xl font-display font-light text-secondary leading-none mb-6 z-10">
                        {t('cta.title', 'Start Your\nInvestment Journey').split('\n').map((line, i) => (
                            <span key={i} className="block">{line}</span>
                        ))}
                    </h2>
                    <p className="text-secondary/60 max-w-md text-lg leading-relaxed z-10">
                        {t('cta.description', 'Contact our experts today and let us guide you through your investment journey.')}
                    </p>
                </div>

                {/* Actions Section */}
                <div className="lg:col-span-5 flex flex-col justify-center items-start lg:pl-12 py-12 lg:py-20 space-y-6">
                    <Link
                        to="/pages/contact-us"
                        className="group w-full md:w-auto relative overflow-hidden bg-secondary text-white px-8 py-5 flex items-center justify-between gap-8 hover:bg-secondary/90 transition-all duration-500"
                    >
                        <span className="relative z-10 font-bold tracking-wider uppercase text-sm">
                            {t('cta.contactUs', 'Contact Us Now')}
                        </span>
                        <ArrowUpRight className="relative z-10 w-5 h-5 transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500" />
                    </Link>

                    <a
                        href={whatsappLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group w-full md:w-auto flex items-center justify-between gap-8 px-8 py-5 border border-secondary/20 hover:border-secondary hover:bg-secondary/5 transition-all duration-300"
                    >
                        <span className="font-bold tracking-wider uppercase text-sm text-secondary">
                            {t('cta.whatsapp', 'Chat on WhatsApp')}
                        </span>
                        <MessageCircle className="w-5 h-5 text-secondary transform group-hover:scale-110 transition-transform duration-300" />
                    </a>
                </div>
            </div>
        </section>
    );
};
